import {
  ProfileAccountInfo,
} from "api/interfaces/accountInterface.interface";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { useAppSelector } from "redux/hooks";
import FirmwareDW from "./firmwareDW";
import FirmwareEU from "./FirmwareUpgrade";

export default function Firmware() {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  if (selectedAccount.accountLevel === LEVEL_TYPE.DW) {
    return <FirmwareDW />;
  }
  return <FirmwareEU />;
}
